<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-20"
      :bodyStyle="{ paddingTop: '20px' }"
    >
      <template #title>
        <h5 class="font-semibold m-0">Alumni Form</h5>
        <!-- <p class="mt-0 mb-0">
          In case of booking a car after working hours, the admin will arrange
          the car within working hours of the following day (9:00 - 16:00).
        </p>
        <p class="mt-0 mb-0">
          For urgent matter, please contact 02-700-5000 Ext.1101 or call
          064-9251438
        </p> -->
      </template>
      <a-form :layout="'horizontal'">
        <div>
          <a-tabs default-active-key="1" @change="callback" type="card">
            <a-tab-pane key="1" tab="Main">
              <span>
                <a-card :bordered="true">
                  <a-row>
                    <a-col :span="4" :offset="4" style="text-align: center">
                      <a-avatar :size="120" shape="square" :src="picture" />
                    </a-col>
                    <a-col :span="6" style="text-align: left; margin-top: 20px">
                      <a-form-item
                        class="mb-20"
                        label=""
                        :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 12 }"
                        help="upload image only jpg, png file."
                      >
                        <a-upload
                          :file-list="fileList"
                          :remove="handleRemove"
                          :before-upload="beforeUpload"
                          :multiple="false"
                          v-model="fileUpload"
                        >
                          <a-button> <a-icon type="upload" /> Upload </a-button>
                        </a-upload>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4" style="padding-top: 10px">
                      <a-form-item
                        label="Name - Surname"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>
                          {{
                            formData.title_en +
                            " " +
                            formData.fname_en +
                            " " +
                            formData.lname_en
                          }}
                        </p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="ขื่อ - นามสกุล"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>
                          {{
                            formData.title +
                            " " +
                            formData.fname_th +
                            " " +
                            formData.lname_th
                          }}
                        </p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Student ID"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.stu_id }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="MUICAA Member"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.muicaa_member }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Major"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.major }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Graduate Year"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.grad_year }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Graduate Date"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.grad_date }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Email"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.email }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Mobile Phone"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>{{ formData.tel_no }}</p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="12" :offset="4">
                      <a-form-item
                        label="Work"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <p>
                          {{
                            formData.work_position + " " + formData.work_company
                          }}
                        </p>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-card>
              </span>
            </a-tab-pane>

            <a-tab-pane key="2" force-render>
              <template #tab>
                <span>
                  <a-icon type="contacts" theme="outlined" />
                  Background
                </span>
              </template>
              <span>
                <a-form :layout="'horizontal'">
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Student ID"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Membership ID"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="10" :offset="2">
                      <a-form-item
                        label="MUICAA Alumni Committee"
                        :label-col="{ span: 10 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Academic Title"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-select
                          show-search
                          placeholder="select..."
                          option-filter-prop="children"
                          v-model="formData.role_and_duty"
                        >
                          <a-select-option
                            v-for="(item, index) in optionAcademicTitle"
                            :key="index"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Title"
                        :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 8 }"
                        extra=""
                      >
                        <a-select
                          show-search
                          placeholder="select..."
                          option-filter-prop="children"
                          v-model="formData.role_and_duty"
                        >
                          <a-select-option
                            v-for="(item, index) in optionTitle"
                            :key="index"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Name"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Surname"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Thai First Name"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Thai Last Name"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Nationality"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Program"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Major"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Minor"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Concentration"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Date of Graduation"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-date-picker
                          class="mr-10"
                          v-model="formData.grad_date"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="G.P.A"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          type="number"
                          step="0.1"
                          min="0.1"
                          max="4.0"
                          v-model="formData.gpa"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Graduate Status"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </span>
            </a-tab-pane>

            <a-tab-pane key="3">
              <template #tab>
                <span>
                  <a-icon type="mail" theme="outlined" />
                  Contact
                </span>
              </template>
              <span>
                <a-form :layout="'horizontal'">
                  <a-row>
                    <a-col :span="10" :offset="2">
                      <a-form-item
                        label="Address"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-textarea
                          placeholder=""
                          :auto-size="{ minRows: 3, maxRows: 5 }"
                          v-model="formData.address"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="10" :offset="2">
                      <a-form-item
                        label="Email"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-input
                          type="email"
                          v-model="formData.email"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="10" :offset="2">
                      <a-form-item
                        label="Mobile Phone"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-input v-model="formData.tel_no" placeholder="" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </span>
            </a-tab-pane>

            <a-tab-pane key="4">
              <template #tab>
                <span>
                  <a-icon type="read" theme="outlined" />
                  Futher Education
                </span>
              </template>
              <span>
                <a-row>
                  <a-col :span="10" :offset="2">
                    <a-form-item
                      label="Education (s)"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-button type="dashed" block @click="addItemEducation">
                        <PlusOutlined />
                        + Add Education
                      </a-button>
                    </a-form-item>
                  </a-col>
                </a-row>
                <hr />
                <a-row>
                  <a-col style="text-align: right">
                    <a-button type="danger" icon="delete" size="normal" />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="10" :offset="2">
                    <a-form-item
                      label="Name of University"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item
                      label="Degree"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item
                      label="Major"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- <hr>
                <a-row>
                  <a-col style="text-align:right">
                    <a-button type="danger" icon="delete" size="normal" />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="10" :offset="2">
                    <a-form-item label="Name of University" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
                      extra="">
                      <a-select show-search placeholder="select..." option-filter-prop="children"
                        v-model="formData.role_and_duty">
                        <a-select-option v-for="(item, index) in optionAcademicTitle" :key="index" :value="item.value">
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item label="Degree" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
                      <a-select show-search placeholder="select..." option-filter-prop="children"
                        v-model="formData.role_and_duty">
                        <a-select-option v-for="(item, index) in optionAcademicTitle" :key="index" :value="item.value">
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item label="Major" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
                      <a-select show-search placeholder="select..." option-filter-prop="children"
                        v-model="formData.role_and_duty">
                        <a-select-option v-for="(item, index) in optionAcademicTitle" :key="index" :value="item.value">
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row> -->
              </span>
            </a-tab-pane>

            <a-tab-pane key="5">
              <template #tab>
                <span>
                  <a-icon type="read" theme="outlined" />
                  Work Experience
                </span>
              </template>
              <span>
                <a-row>
                  <a-col :span="10" :offset="2">
                    <a-form-item
                      label="Work Experience (s)"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-button type="dashed" block @click="addItemEducation">
                        <PlusOutlined />
                        + Add Experience
                      </a-button>
                    </a-form-item>
                  </a-col>
                </a-row>

                <hr />
                <a-row>
                  <a-col style="text-align: right">
                    <a-button type="danger" icon="delete" size="normal" />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="10" :offset="2">
                    <a-form-item
                      label="Position"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item
                      label="Company"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item
                      label="Job sectors"
                      :label-col="{ span: 8 }"
                      :wrapper-col="{ span: 16 }"
                      extra=""
                    >
                      <a-select
                        show-search
                        placeholder="select..."
                        option-filter-prop="children"
                        v-model="formData.role_and_duty"
                      >
                        <a-select-option
                          v-for="(item, index) in optionAcademicTitle"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <!-- <hr> -->
              </span>
            </a-tab-pane>

            <a-tab-pane key="6">
              <template #tab>
                <span>
                  <a-icon type="trophy" theme="outlined" />
                  Achievements
                </span>
              </template>
              <span>
                <a-form :layout="'horizontal'">
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Achievement (s)"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-button type="dashed" block @click="addItemEducation">
                          <PlusOutlined />
                          + Add Achievement
                        </a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <hr />
                  <a-row>
                    <a-col style="text-align: right">
                      <a-button type="danger" icon="delete" size="normal" />
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Name of Award"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Date of Receive"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-date-picker
                          class="mr-10"
                          v-model="formData.grad_date"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Oranizaed by"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Location"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Type (Choices) "
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-select
                          show-search
                          placeholder="select..."
                          option-filter-prop="children"
                          v-model="formData.role_and_duty"
                        >
                          <a-select-option
                            v-for="(item, index) in optionAcademicTitle"
                            :key="index"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </span>
            </a-tab-pane>

            <a-tab-pane key="7">
              <template #tab>
                <span>
                  <a-icon type="team" theme="outlined" />
                  Engagement
                </span>
              </template>
              <span>
                <a-form :layout="'horizontal'">
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Engagement (s)"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 16 }"
                        extra=""
                      >
                        <a-button type="dashed" block @click="addItemEducation">
                          <PlusOutlined />
                          + Add Engagement
                        </a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <hr />
                  <a-row>
                    <a-col style="text-align: right">
                      <a-button type="danger" icon="delete" size="normal" />
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Activity Name"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Date of Activity"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-date-picker
                          class="mr-10"
                          v-model="formData.grad_date"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Role and Duty"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-select
                          show-search
                          placeholder="select..."
                          option-filter-prop="children"
                          v-model="formData.role_and_duty"
                        >
                          <a-select-option
                            v-for="(item, index) in optionAcademicTitle"
                            :key="index"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Doncation"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8" :offset="2">
                      <a-form-item
                        label="Organized by"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="10">
                      <a-form-item
                        label="Location"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }"
                        extra=""
                      >
                        <a-input
                          v-model="formData.activity_name"
                          placeholder=""
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </span>
            </a-tab-pane>
          </a-tabs>
        </div>

        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button type="primary" @click="visible = true" class="mr-10">
            Print
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal
      title="Confirm"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submitFormBookCar"
      @cancel="visible = false"
    >
      <p>Are you sure to Submit ?</p>
    </a-modal>

    <!-- <a-modal title="Confirm" :visible="isVisibleForgotSubmit" :confirm-loading="confirmLoading" @ok="submitFormBookCar"
      @cancel="visible = false">
      <p>คุณยังไม่ได้บันทึกข้อมูล จะบันทึกข้อมูลก่อนหรือไม่?</p>
    </a-modal> -->

    <!-- <a-space v-for="(item, index) in educationItems " :key="index" style="display: flex; margin-top:5px" align="none">
      <a-form-item :rules="{
        required: true,
        message: 'Missing item name',
      }">
        <a-input v-model:value="item.university" placeholder="University name" />
      </a-form-item>
      <a-icon type="minus-circle" theme="outlined" @click="removeItem(item)" />
    </a-space> -->
  </div>
</template>

<script>
import authService from "../../services/authService";

// import ProfileFutherEducation from './profile/ProfileFutherEducation.vue'
const form = {
  stu_id: "",
  membership_id: "",
  muicaa_member: "",
  acadamic_title: "",
  title: "",
  title_en: "",
  fname_en: "John",
  lname_en: "Tilfare",
  fname_th: "",
  lname_th: "",
  nation: "",
  program: "",
  major: "",
  minor: "",
  concentration: "",
  grad_date: "",
  grad_year: "",
  grad_status: "",
  gpa: "",
  email: "",
  tel_no: "",
  work_position: "",
  work_company: "",
  family_own_business: "",
  job_sectors: "",
};
export default {
  data() {
    return {
      formData: Object.assign({}, form),
      educationItems: [],
      optionReson: [],
      loadBtnSubmit: false,
      optionAcademicTitle: [],
      optionTitle: [],
      listEducation: [{ a: "Hello World!" }],
      // file upload
      fileList: [],
      uploading: false,
      fileUpload: null,
      picture: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      errorSubmit: "",
      visible: true,
      isVisibleForgotSubmit: true,
      confirmLoading: false,
    };
  },
  mounted() {
    this.formData.email = authService.getUsername();
    this.getResonList();
  },
  computed: {
    getListEducation() {
      return this.listEducation;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileUpload = file;
      this.fileList = [...this.fileList, file];
      return false;
    },
    isformData() {
      if (this.formData.email !== "") {
        return true;
      } else {
        return false;
      }
    },
    isTimeBooking() {
      if (this.formData.timeStart !== "" && this.formData.timeEnd !== "") {
        var start = `${this.moment(this.formData.dayStart).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeStart, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        var end = `${this.moment(this.formData.dayEnd).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeEnd, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        var ms = this.moment(start, "DD/MM/YYYY HH:mm:ss").diff(
          this.moment(end, "DD/MM/YYYY HH:mm:ss")
        );
        // //console.log(ms)
        // var d = this.moment.duration(ms);
        // //console.log(d._milliseconds)
        if (ms > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    // addList: function () {
    //   this.listEducation.push({ a: 'abc' });
    //   //console.log(this.listEducation)
    // },
    //item engagement
    addItemEducation() {
      this.educationItems.push({
        university: "",
        degree: "",
        major: "",
      });
    },
    removeItem(item, listName) {
      //console.log(item);
      let index = this["listName"].indexOf(item);
      if (index !== -1) {
        this["listName"].splice(index, 1);
      }
    },
    addList: function () {
      this.listEducation.push({ a: "Hello World!" });
    },
    onAddSectionEducation() {
      this.listEducation.push("item");
      //console.log(this.listEducation);
    },
    callback(tabIndex) {
      //console.log(tabIndex);
      // if(tabIndex==1){
      //   this.isVisibleForgotSubmit=true
      // }
    },
    async getResonList() {
      this.optionReson = [];
      try {
        const res = await this.$http.get(`/vehicle/reason/`);
        if (res.status === 200) {
          this.optionReson = res.data.map((item) => {
            return {
              value: item.id,
              text: `${item.eng_detail}`,
            };
          });
        } else {
          throw { res };
        }
      } catch (error) {}
    },
    clearForm() {
      this.formData = Object.assign({}, form);
      this.formData.email = authService.getUsername();
      this.$router
        .push({
          path: "/alumni",
        })
        .catch((err) => {});
    },
    async submitFormBookCar() {
      this.loadBtnSubmit = true;
      this.errorSubmit = null;
      const sendData = new FormData();
      sendData.append("email", this.formData.email);
      sendData.append("destination", this.formData.Destination);
      sendData.append("reason", this.formData.reason);
      sendData.append("passenger", this.formData.passenger);
      sendData.append(
        "use_start",
        this.moment(this.formData.dayStart).format("YYYY-MM-DD") +
          "T" +
          this.moment(this.formData.timeStart, "HH:mm:ss").format("HH:mm:ss") +
          "+07:00"
      );
      sendData.append(
        "use_end",
        this.moment(this.formData.dayEnd).format("YYYY-MM-DD") +
          "T" +
          this.moment(this.formData.timeEnd, "HH:mm:ss").format("HH:mm:ss") +
          "+07:00"
      );
      if (this.formData.Remark !== "" || this.formData.Remark !== null) {
        sendData.append("remark", this.formData.Remark);
      } else {
        sendData.append("remark", "-");
      }
      try {
        const response = await this.$http.post("/vehicle/booking/", sendData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 201) {
          this.clearForm();
          this.visible = false;
        } else {
          throw { response };
        }
      } catch (error) {
        this.loadBtnSubmit = false;
        this.errorSubmit = error;
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /vehicle/booking/`,
        });
      }
    },
  },
  // components: {
  //   ProfileFutherEducation
  // }
};
</script>
